export default __webpack_public_path__ + "static/media/ico_14.3a0b358a.png";